import axios from 'axios';

// Create axios instance with base URL from environment
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001'
});

// Add request interceptor to log the full URL
api.interceptors.request.use(config => {
  // Log the full URL being requested
  console.log('Making request to:', {
    baseURL: config.baseURL,
    url: config.url,
    fullURL: `${config.baseURL}${config.url}`,
    method: config.method
  });
  return config;
});

// Debug log for API URL
console.log('API Configuration:', {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV,
  baseURL: api.defaults.baseURL
});

export default api; 